import { isEqual } from 'lodash';
import { IFilterComparator, ESGFilterModel } from '../../filter-types';

export class ESGFilterModelComparator
  implements IFilterComparator<ESGFilterModel> {
  applyFilterOptions(options: string[]) {
    return;
  }

  hasValidDiff(grid: Partial<ESGFilterModel>, store: ESGFilterModel): boolean {
    if (!grid) {
      return true;
    }
    if (
      isEqual(
        grid.selectedTypes.isInclusive,
        store.selectedTypes.isInclusive
      ) &&
      isEqual(
        grid.selectedTypes.storeValues,
        store.selectedTypes.storeValues
      ) &&
      isEqual(
        grid.selectedVerifiers.isInclusive,
        store.selectedVerifiers.isInclusive
      ) &&
      isEqual(
        grid.selectedVerifiers.storeValues,
        store.selectedVerifiers.storeValues
      ) &&
      grid.selectedPreQualified === store.selectedPreQualified &&
      isEqual(grid.isFilterActive, store.isFilterActive)
    ) {
      return false;
    }

    return true;
  }
}
